<div class="flow-config-modal">
  <h2 class="dialog-title">
    <nz-icon nzType="setting" nzTheme="outline"></nz-icon>
    Configurar Execução de Fluxo
  </h2>

  <div class="dialog-content">
    <form [formGroup]="form" class="flow-config-form">
      
      <!-- Campo de busca para IDCONF -->
      <div class="form-field">
        <label class="required">{{ 'builderScreen.flowConfig.title' | translateTA }}</label>
        
        <div class="search-box">
          <div class="search-input-wrapper">
            <nz-icon nzType="search" class="search-prefix"></nz-icon>
            <input 
              type="text"
              class="search-input"
              [(ngModel)]="searchText"
              [ngModelOptions]="{standalone: true}"
              (ngModelChange)="onSearchChange($event)"
              [placeholder]="'builderScreen.flowConfig.searchPlaceholder' | translateTA"
              [disabled]="loading"
              autocomplete="off">
            <button
              *ngIf="selectedConfiguration"
              nz-button
              nzType="text"
              nzShape="circle"
              nzSize="small"
              class="search-clear"
              (click)="clearSelection()"
              type="button">
              <nz-icon nzType="close"></nz-icon>
            </button>
          </div>

          <!-- Lista de resultados -->
          <div class="results-list" *ngIf="filteredConfigurations.length > 0 && !selectedConfiguration && searchText">
            <div 
              *ngFor="let config of filteredConfigurations | slice:0:10"
              class="result-item"
              (click)="selectConfiguration(config)">
              <div class="result-main">
                <span class="result-id">#{{ config.IDCONF }}</span>
                <span class="result-name">{{ config.NAME }}</span>
              </div>
              <div class="result-meta">
                <span class="result-mktp">{{ config.CODEMKTP_NAME }}</span>
                <span class="result-company">{{ config.CODECOMPANY_NAME }}</span>
                <span class="result-engine" [class.is-new]="config.NEWMODE === 'S'">
                  {{ config.NEWMODE === 'S' ? 'Fluxo novo' : 'Fluxo antigo' }}
                </span>
              </div>
            </div>
            <div *ngIf="filteredConfigurations.length === 0" class="no-results">
              Nenhuma configuração encontrada
            </div>
          </div>

          <!-- Configuração selecionada -->
          <div class="selected-config" *ngIf="selectedConfiguration">
            <nz-icon nzType="check-circle" nzTheme="outline" class="selected-icon"></nz-icon>
            <div class="selected-info">
              <div class="selected-main">
                <strong>#{{ selectedConfiguration.IDCONF }}</strong> - {{ selectedConfiguration.NAME }}
              </div>
              <div class="selected-meta">
                {{ selectedConfiguration.CODEMKTP_NAME }} | {{ selectedConfiguration.CODECOMPANY_NAME }}
                &nbsp;&middot;&nbsp;
                <strong>{{ selectedConfiguration.NEWMODE === 'S' ? 'Fluxo novo (assíncrono)' : 'Fluxo antigo' }}</strong>
              </div>
            </div>
          </div>

          <!-- Loading -->
          <div class="loading-indicator" *ngIf="loading">
            <nz-icon nzType="sync" nzSpin class="spin"></nz-icon>
            Carregando configurações...
          </div>
        </div>
        
        <small class="help-text">{{ 'builderScreen.flowConfig.help' | translateTA }}</small>
      </div>

      <!-- Checkbox: Permitir seleção de empresa -->
      <div class="form-field">
        <label nz-checkbox formControlName="showCodeCompany">
          Permitir que o usuário selecione a empresa ao executar
        </label>
        <small class="help-text">
          Se ativado, o usuário poderá escolher a empresa no momento da execução
        </small>
      </div>

      <!-- Select: Empresa Fixa -->
      <div class="form-field" *ngIf="!form.get('showCodeCompany')?.value">
        <label>Empresa Fixa</label>
        <select 
          class="custom-select"
          formControlName="codeCompany">
          <option [value]="null">{{ 'builderScreen.flowConfig.loggedUserCompany' | translateTA }}</option>
          <option 
            *ngFor="let company of userCompanies" 
            [value]="company.codecompany">
            {{ company.codecompany }} - {{ company.companyname }}
          </option>
        </select>
        <small class="help-text">
          Deixe vazio para usar a empresa do usuário logado
        </small>
      </div>

    </form>
  </div>

  <div class="dialog-actions">
    <button nz-button nzType="default" type="button" (click)="onCancel()">
      <nz-icon nzType="close"></nz-icon>
      Cancelar
    </button>
    <button nz-button nzType="primary" type="button" (click)="onSave()" [disabled]="!isValid">
      <nz-icon nzType="check"></nz-icon>
      Confirmar
    </button>
  </div>
</div>
